import { render } from "./ContextMenuMain.vue?vue&type=template&id=c272d986&scoped=true"
import script from "./ContextMenuMain.vue?vue&type=script&lang=js"
export * from "./ContextMenuMain.vue?vue&type=script&lang=js"

import "./ContextMenuMain.vue?vue&type=style&index=0&id=c272d986&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c272d986"]])

export default __exports__